import loginUser from 'client/hooks/useInitPromo/userLoginState/loginUser';
import getLoginUserNonQualifyType from 'client/hooks/useInitPromo/userLoginState/getLoginUserNonQualifyType';
import { gameTypes } from 'config/promoGameTypes';
import { gameRunningStatuses } from 'config/gameRunningStatuses';

// 未發佈、未開始都不做登入
const omitLoginGameStatuses = new Set([
    gameRunningStatuses.NOT_PUBLISH,
    gameRunningStatuses.BEFORE
]);

export default async function getUserLoginState(state, gameType) {
    const {
        settingPromo: { loginMethod },
        sponsor,
        partner,
        promoState: {
            gameRunningStatus,
            periodPlayMatchedInfo: { matchedInfo: { match: isInPlayTimePeriod } = {} } = {}
        }
    } = state;
    const noNeedLogin =
        omitLoginGameStatuses.has(gameRunningStatus) || gameType === gameTypes.CONTEST_ADMIN_UPLOAD;

    const isLogin = noNeedLogin
        ? false
        : await loginUser(loginMethod, {
              partner,
              sponsor
          });

    const isPromoPlayableOnTime =
        gameRunningStatus === gameRunningStatuses.RUNNING && isInPlayTimePeriod;
    const { notQualifiedType = '', notQualifiedErrInfo = {} } =
        isLogin && isPromoPlayableOnTime ? await getLoginUserNonQualifyType(state) : {};

    return { isLogin, notQualifiedType, notQualifiedErrInfo };
}
